import { defineComponent } from 'vue';
import __vue_component__ from '../../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__$1 from '../../../../../../ui/Icon.vue.js';

var script = defineComponent({
    name: 'TestModalComponent',
    components: { ButtonComponent: __vue_component__, Icon: __vue_component__$1 },
    props: {
        text: {
            type: String,
            required: true,
        },
    },
    setup() {
        return {};
    },
});

export { script as default };
